import React from 'react'
import ProductFilter from "@components/product/filters/product-filter"
import ProductSort from "@components/product/sorting"
import ItemsPerPageSelector from "@components/items-per-page-selector"
import { formatProductGroups } from '../helpers'

const ProductFiltersDesktop = ({ 
  allProductGroups, 
  selectedProductGroup, 
  sortingOptions, 
  setSortingOptions, 
  itemsPerPage, 
  setItemsPerPage, 
  searchItem, 
  sortedProducts,
}) => {
  return (
    <>
      <div className="col-span-1 md:col-span-4 hidden md:block opacity-100">
        <ItemsPerPageSelector 
          setItemsPerPage={setItemsPerPage} 
          itemsPerPage={itemsPerPage}
          sortedProducts={sortedProducts}
        />
      </div>
      <div className="col-span-1 hidden md:block">
        <div className="flex flex-col sticky top-16 z-10">
          <ProductSort sortingOptions={sortingOptions} setSortingOptions={setSortingOptions} />
          <div className="flex flex-col">
            {searchItem && 
              <ProductFilter query={searchItem} />
            }
            {formatProductGroups(allProductGroups, selectedProductGroup)?.map((group, index) => 
              <ProductFilter key={index} group={group} index={index} />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ProductFiltersDesktop